
export default class Common {

	static async fetch( url, options = {} ) {
		
		let defaults = {
			method: 'GET', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, *cors, same-origin
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, *same-origin, omit
			headers: {
				//'Content-Type': 'application/json'
				//'Content-Type': 'application/x-www-form-urlencoded',
				//'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
			redirect: 'follow', // manual, *follow, error
			referrerPolicy: 'no-referrer-when-downgrade', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
		};
		let allOptions = Object.assign( defaults, options );
		let response = await fetch( url, allOptions );
		return response;
	}

	static htmlToText = ( html ) => {

		let text = html;
		let span = document.createElement( 'span' );

		if ( text === null || text === undefined ) {

			text = "";
		}

		text = text.replace( /[\r\n]{0,2}/gi, "" );
		text = text.replace( /<style([\s\S]*?)<\/style>/gi, "" );
		text = text.replace( /<script([\s\S]*?)<\/script>/gi, "" );
		text = text.replace( /<a.*?href="(.*?)[\?\"].*?>(.*?)<\/a.*?>/gi, " $2 $1 " );
		text = text.replace( /<\/div>/gi, "\\n\\n" );
		text = text.replace( /<\/li>/gi, "\\n" );
		text = text.replace( /<li.*?>/gi, "  *  " );
		text = text.replace( /<\/ul>/gi, "\n\n" );
		text = text.replace( /<\/p>/gi, "\\n\\n" );
		text = text.replace( /<br\s*[\/]?>/gi, "\\n" );
		text = text.replace( /<[^>]+>/gi, "" );
		text = text.replace( /^\s*/gim, "" );
		text = text.replace( / ,/gi, "," );
		text = text.replace( / +/gi, " " );
		text = text.replace( /[\r\n]+/gi, "\\n\\n" );
		text = text.replace( /&#(\d+);/g, ( match, dec ) => {
			return String.fromCharCode( dec );
		} );
		text = text.replace( /&[#A-Za-z0-9]+;/gi, ( entity, position, text ) => {
			span.innerHTML = entity;
			return span.innerText;
		} );

		span.remove();
		return text;
	}

	static isEmpty( a ) {

		let empty = false;

		if( Array.isArray( a ) ) {

			empty = ( a.length > 0 ) ? true : false;
		} else if( typeof a === "object" ) {

			let keys = Object.keys( a );
			empty = ( keys.length > 0 ) ? true : false;
		} else if( typeof a === "string" ) {

			empty = ( a.replace( /\s+/g, '' ) === "" ) ? true : false
		}
		return empty;
	}
	
	static async post( url, data, options = {} ) {

		let form = new FormData();
		let keys = Object.keys( data );
		
		let defaults = {
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, *cors, same-origin
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, *same-origin, omit
			headers: {
				//'Content-Type': 'application/json'
				//'Content-Type': 'application/x-www-form-urlencoded',
				//'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
			redirect: 'follow', // manual, *follow, error
			referrerPolicy: 'no-referrer-when-downgrade', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
			body: form, //JSON.stringify( data ) // body data type must match "Content-Type" header
		};
		let allOptions = Object.assign( defaults, options );

		keys.forEach( i => {
			form.append( i, data[`${i}`] )
		});

		let response = await fetch( url, allOptions );
		return response;
	}
}
